import { ApiBase } from './ApiBase';
class PaidDomainsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getPaidDomains = () => {
            return this.get('/paid-domains');
        };
        this.registerPaidDomain = (params) => {
            return this.post('/paid-domains/register', params);
        };
        this.getSuggestions = (params) => {
            return this.get('/paid-domains/suggestions', params);
        };
    }
}
export const PaidDomainsApiClient = new PaidDomainsApiClientModel();
